module.exports = __webpack_public_path__ + "static/media/ic_expectations.4b04d7c3.svg";